import { Moment } from "moment";
import { mutatorAction } from "satcheljs";
import { shiftEditorViewState } from "..";

export default mutatorAction("updateStartTimeOpenShift", function updateStartTimeOpenShift(newTime: Moment) {
    if (shiftEditorViewState().openShift && newTime) {
        shiftEditorViewState().openShift.startTime = newTime.clone();
    }
});